const actions = {
  ADD_TOPIC: 'ADD_TOPIC',
  REMOVE_TOPIC: 'REMOVE_TOPIC',
  ADD_POPUP: 'ADD_POPUP',
  REMOVE_POPUP: 'REMOVE_POPUP',
  SET_SIDEBAR_OPEN: 'SET_SIDEBAR_OPEN',
  SET_SIDEBAR_OPENING: 'SET_SIDEBAR_OPENING',
  NAVIGATE_PUSH: 'NAVIGATE_PUSH',
  NAVIGATE_POP: 'NAVIGATE_POP',
  NAVIGATE_REPLACE: 'NAVIGATE_REPLACE',
  NAVIGATE_RESET: 'NAVIGATE_RESET',
  SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
  SET_IS_SEARCHING: 'SET_IS_SEARCHING',
  HIDE_POPUP: 'HIDE_POPUP',
  SET_HIDDEN_POPUPS: 'SET_HIDDEN_POPUPS',
  RESET: 'RESET'
}

export default actions
